export default {
	styleOverrides: {
		root: {}
	}
};
